import { render, staticRenderFns } from "./main.vue?vue&type=template&id=9b10a336&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=9b10a336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b10a336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b10a336')) {
      api.createRecord('9b10a336', component.options)
    } else {
      api.reload('9b10a336', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=9b10a336&scoped=true&", function () {
      api.rerender('9b10a336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/hint/main.vue"
export default component.exports